import API from '../../../api/API';

export default class IndexationAPI extends API {
  constructor(parameters = {}) {
    super('/IndexationKind', parameters);
  }

  loadAllIndexations() {
    return this.submit("get", `${this.endpoint}`);
  }

  setIndexation(indexation) {
    return this.submit("post", `${this.endpoint}`, indexation);
  }

  editIndexation(indexation) {
    return this.submit("put", `${this.endpoint}/${indexation.id}`, indexation);
  }
}
